import { render } from "./HousesPage.vue?vue&type=template&id=10a1ed73"
import script from "./HousesPage.vue?vue&type=script&lang=js"
export * from "./HousesPage.vue?vue&type=script&lang=js"

import "./HousesPage.vue?vue&type=style&index=0&id=10a1ed73&lang=css"
script.render = render

export default script